import styled,{ css } from 'styled-components'

export const Container = styled.div`
    padding: 1rem;
    border-radius: 0.25rem;
    background: var(--colorBackgroundSubCardsDashboard);
    width: 32%;
    margin: 2px;
    position: relative;

    display: flex;
    align-items: center;
    justify-content: center;

    .checkbox {
        position: absolute;
        top: 5px;
        right: -0.7rem;
    }

    @media (max-width: 1859px){
        width: 48%;
    }

    @media (max-width: 1307px){
        width: 96%;
    }

    @media (max-width: 350px){
        flex-direction: column;
    }
`

export const Gauge = styled.div`
    min-width: 50%;
    margin-right: 0.5rem;

    @media (max-width: 350px){
        margin-bottom: 0.5rem;
        width: 90%;
    }

    .gaugeBody{
        width: 100%;
        height: 0;
        padding-bottom: 50%;
        background: #B4C0BE;
        position: relative;
        border-top-left-radius: 100% 200%;
        border-top-right-radius: 100% 200%;
        overflow: hidden;
       
        .gaugeFill{
            position: absolute;
            top: 99.9%;
            left: 0;
            width: inherit;
            height: 100%;
            transform-origin: center top;
            transition: transform 1.5s ease;
            transform: rotate(0turn);

            ${props => props.colorBackgroundGauge && css`
                background: ${props.colorBackgroundGauge};
            `}

            ${props => props.percentage && props.gaugeAnimation && css`
                transform: rotate(${props.percentage}turn);
            `}
        }

        .gaugeCover{
            width: 75%;
            height: 150%;
            background: var(--colorBackgroundSubCardsDashboard);
            position: absolute;
            border-radius: 50%;
            top: 25%;
            left: 50%;
            transform: translateX(-50%);

            display: flex;
            align-items: center;
            justify-content: center;
            padding-bottom: 25%;

            strong{
                font-size: 1rem;
                color: var(--colorFontsCardsDashboard);

                @media (max-width: 1307px){
                    font-size: 1.5rem;
                }
            }
        }

    }
`

export const ChannelInformations = styled.div`
    color: var(--colorFontsCardsDashboard);
    font-size: 0.7rem;
    font-weight: 500;
    min-width: 30%;

    .title{
        font-size: 1rem;
        @media (max-width: 1307px){
            font-size: 1.1rem;
        }
    }

    p + p{
        margin-top: 0.2rem;
    }

    div{
        display: flex;
        align-items: center;
        margin-top: 0.2rem;
        
        p{
            margin-top: 0;
            margin-right: 0.2rem;
        }
    }

    @media (max-width: 1307px){
        font-size: 0.8rem;
    }
`